import React, { PureComponent, Fragment } from 'react';

import { css } from 'react-emotion';
import { components } from '@peachjar/components';

const { NumberedRow, Buttons } = components;
const {
  ButtonPrimaryLarge,
  ButtonSecondaryLarge,
  ButtonSecondarySmall,
} = Buttons;

const CSV_BOX_HEIGHT_BEFORE = '487px';
const CSV_BOX_HEIGHT_AFTER = '387px';
const PROGRESS_BOX_HEIGHT = '84px';

const INSTRUCTIONS_PDF_URL =
  'http://cdn-assets.peachjar.com/portal-app/onboarding/staff/District+Staff+List+CSV+Instructions.pdf';
const SINGLE_SCHOOL_INSTRUCTIONS_PDF_URL =
  'http://cdn-assets.peachjar.com/portal-app/onboarding/staff/Single+School+Staff+CSV+Instructions.pdf';
const CSV_TEMPLATE_URL =
  'http://cdn-assets.peachjar.com/portal-app/onboarding/staff/staff+(district+site).csv';
const SINGLE_SCHOOL_CSV_TEMPLATE_URL =
  'http://cdn-assets.peachjar.com/portal-app/onboarding/staff/staff+(single+site).csv';

export default class DownloadButtonSection extends PureComponent {
  render() {
    const {
      handleInstructionsDownload,
      handleCsvTemplateDownload,
      ncesSchoolId,
      showCsvTemplateButton,
    } = this.props;
    return (
      <Fragment>
        <div className={styles.row}>
          <p>
            To make this easier we created some instructions on how to prepare
            your CSV file for upload.
          </p>
          <ButtonSecondarySmall
            onClick={handleInstructionsDownload}
            href={
              ncesSchoolId
                ? SINGLE_SCHOOL_INSTRUCTIONS_PDF_URL
                : INSTRUCTIONS_PDF_URL
            }
            target="_blank"
            data-testid="click-instructions"
          >
            View Instructions
          </ButtonSecondarySmall>
        </div>
        <div className={styles.row}>
          <p>
            Once you&apos;ve reviewed the instructions, download the template
            below to enter your staff list.
          </p>
          {showCsvTemplateButton ? (
            <ButtonSecondarySmall
              onClick={handleCsvTemplateDownload}
              data-testid="click-csv-template"
              href={
                ncesSchoolId ? SINGLE_SCHOOL_CSV_TEMPLATE_URL : CSV_TEMPLATE_URL
              }
              target="_blank"
            >
              Download Template
            </ButtonSecondarySmall>
          ) : (
            <ButtonSecondarySmall disabled data-testid="click-csv-template">
              Download Template
            </ButtonSecondarySmall>
          )}
        </div>
      </Fragment>
    );
  }
}

const styles = {
  row: css`
    margin-bottom: 32px;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/components/DownloadButtonSection.jsx